module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldIt.4502137.woff";